export default function Hero() {
  return (
    <section className="bg-hero-radial">
      <div className="container-x pt-14 pb-10 md:pt-20 md:pb-16">
        <div className="grid gap-10 md:grid-cols-12 md:items-center">
          <div className="md:col-span-7">
            <div className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-3 py-1 text-xs text-white/70">
              <span className="h-2 w-2 rounded-full bg-primary" />
              <span>From 402 to receipt — a lower-cost settlement layer</span>
            </div>
            <h1 className="mt-5 text-4xl font-semibold tracking-tight md:text-6xl">
              Make startup ideals
              <span className="text-primary"> shippable</span>.
            </h1>
            <p className="mt-5 max-w-2xl text-base leading-relaxed text-white/65 md:text-lg">
              Soulon is building infrastructure for multi-chain experiences: portable memory and identity, composable payments and settlement,
              and a path that turns promises into auditable receipts.
            </p>
            <div className="mt-7 flex flex-col gap-3 sm:flex-row">
              <a
                href="#how"
                className="inline-flex items-center justify-center rounded-full bg-primary px-6 py-3 text-sm font-semibold text-black transition hover:bg-[#12d584]"
              >
                See how it works
              </a>
              <a
                href="#cta"
                className="inline-flex items-center justify-center rounded-full border border-white/10 bg-white/5 px-6 py-3 text-sm font-semibold text-white/85 transition hover:bg-white/10 hover:text-white"
              >
                Partner / Join
              </a>
            </div>
            <div className="mt-8 grid grid-cols-2 gap-4 md:grid-cols-3">
              <Metric label="Multi-chain assets" value="SOL / USDC" hint="Solana / Base / Polygon" />
              <Metric label="Promise semantics" value="Exact Amount" hint="Exact target asset delivery" />
              <Metric label="Auditable outcome" value="Receipt" hint="Tx + supplement + latency" />
            </div>
          </div>

          <div className="md:col-span-5">
            <div className="glass p-6 md:p-8">
              <div className="flex items-center gap-3">
                <img
                  src="/assets/ic_splash_logo.png"
                  alt="Soulon logo"
                  className="h-12 w-12 rounded-xl border border-white/10 bg-black/30 object-contain"
                />
                <div>
                  <div className="text-sm font-semibold">Soulon</div>
                  <div className="text-xs text-white/55">Memory · Identity · Payments</div>
                </div>
              </div>
              <div className="mt-6 grid gap-3">
                <CardLine title="x402 Compatibility" desc="Works with third-party 402 challenges without private fields." />
                <CardLine title="Negotiation Engine" desc="8 rounds of constrained negotiation to lower fees with clarity." />
                <CardLine title="Settlement Orchestrator" desc="Compiles offers into execution plans and auditable receipts." />
              </div>
              <div className="mt-6 rounded-xl border border-white/10 bg-white/5 p-4">
                <div className="text-xs text-white/60">Current focus</div>
                <div className="mt-1 text-sm text-white/80">
                  Solana pay → receive Base USDC: end-to-end 402 → negotiate → commit → execute → receipt
                </div>
              </div>
              <div className="mt-6 flex flex-wrap gap-2 text-xs text-white/55">
                <Tag>Security-first</Tag>
                <Tag>Deterministic settlement</Tag>
                <Tag>Composable</Tag>
                <Tag>Observable</Tag>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

function Metric(props: { label: string; value: string; hint: string }) {
  return (
    <div className="rounded-2xl border border-white/10 bg-white/5 p-4">
      <div className="text-xs text-white/55">{props.label}</div>
      <div className="mt-1 text-lg font-semibold text-white">{props.value}</div>
      <div className="mt-1 text-xs text-white/45">{props.hint}</div>
    </div>
  )
}

function CardLine(props: { title: string; desc: string }) {
  return (
    <div className="rounded-xl border border-white/10 bg-surface2/70 p-4">
      <div className="text-sm font-semibold text-white/90">{props.title}</div>
      <div className="mt-1 text-xs leading-relaxed text-white/55">{props.desc}</div>
    </div>
  )
}

function Tag(props: { children: string }) {
  return <span className="rounded-full border border-white/10 bg-white/5 px-3 py-1">{props.children}</span>
}
